export const RESERVED_SENDER_DOMAINS = [
  "super-user-manager.com",
  "superusermanager.com",
] as const;

export const isReservedSenderDomain = (
  email: string | null | undefined
): boolean => {
  if (!email) return false;
  const lower = email.toLowerCase();
  return RESERVED_SENDER_DOMAINS.some((d) => lower.endsWith(`@${d}`));
};
